import React, { ReactNode } from 'react';
import { Col, Container, Row } from 'reactstrap';
import classNames from 'classnames';
import Search from './Search';

interface HeaderProps {
    children?: ReactNode;
    headerClassName?: string;
    hideSearch?: boolean;
}

const Header: React.FC<HeaderProps> = ({
    children,
    headerClassName,
    hideSearch
}) => {
    const headerClasses = classNames('hero-wrapper', headerClassName);

    return (
        <header className={headerClasses}>
            <div className='hero-overlay'></div>
            <Container className='hero-content'>
                <Row>
                    <Col
                        xs={12}
                        className='d-flex flex-column justify-content-center align-items-center'
                    >
                        {children}
                        {!hideSearch && <Search />}
                    </Col>
                </Row>
            </Container>
        </header>
    );
};

export default Header;
